import { connect } from 'react-redux';

import Footer from './Footer';
import { getHuggg, hasPrepaidCardVoucher } from 'redux/modules/huggg';

const mapStateToProps = state => {
  return {
    huggg: getHuggg(state),
    hasPrepaidCardVoucher: hasPrepaidCardVoucher(state),
  };
};

export default connect(mapStateToProps)(Footer);
